import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import styled from 'styled-components';
import HeaderInfoM from '../lib/typography/HeaderInfoM';
import { getAlergensMap } from '../utils/getAlergens';

function isValid(value) {
  return value.length >= 0 && value.length < 255;
}

const Wrapper = styled.div`
  display: flex;
  justifyContent: center;
  flex-direction: column;
  padding: 15px;
  border 1px solid #CCC;
  border-radius: 6px;
`;

export const EditAlergensTags = ({ product, type, setFieldValue }) => {
  const incomingAlergens = product[type]
    ? product[type].reduce((a, v) => ({ ...a, [v]: true }), {})
    : {};

  const [expanded, setExpanded] = useState(Object.keys(incomingAlergens).length > 0);
  const [alergens, setAlergens] = useState(incomingAlergens);

  useEffect(() => {
    const arrayOfAlergens = Object.keys(alergens).sort((a, b) => Number(a) - Number(b));
    setFieldValue(type, arrayOfAlergens);
  }, [alergens]);

  const handleToggleExpand = () => {
    if (expanded) {
      setAlergens({});
    }
    setExpanded((prev) => !prev);
  };

  const handleToggleAlergen = (alergenIndex) => {
    const newAlergens = { ...alergens };
    if (alergens[alergenIndex]) {
      delete newAlergens[alergenIndex];

      setAlergens(newAlergens);
    } else {
      newAlergens[alergenIndex] = true;
      setAlergens(newAlergens);
    }
  };

  const availableAlergens = getAlergensMap();

  return (
    <>
      <FormControlLabel
        control={<Switch checked={expanded} onChange={handleToggleExpand} />}
        label="Alergens"
      />
      {expanded && (
        <Wrapper>
          <FormGroup>
            {Object.keys(availableAlergens).map((alergenIndex, index) => {
              const label = { inputProps: { 'aria-label': alergenIndex } };
              return (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      {...label}
                      onChange={() => handleToggleAlergen(alergenIndex)}
                      checked={alergens[alergenIndex] === true}
                    />
                  }
                  label={availableAlergens[alergenIndex]}
                />
              );
            })}
          </FormGroup>
        </Wrapper>
      )}
    </>
  );
};
